import AppRouter from "@/common/app/router";
import HYLink from "@/common/components/link/link";
import KST from "@/common/tools/kst";
import ModuleTM from "@/modules/tm";
import TMModel from "@/modules/tm/api/tm/tm-model";
import { message, Modal, Spin } from "antd";
import React, { MouseEvent, useCallback, useEffect, useState } from "react";
import styles from "./index.module.scss";

const Api = ModuleTM.Api;

export interface TMTransferListItemProps {
  hasLogin: boolean;
  model: TMModel;
}

const TMTransferListItem: React.FC<TMTransferListItemProps> = (props) => {
  const { hasLogin, model } = props;
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [sameData, setSameData] = useState<TMModel[]>();

  let photo = model.extend.photo;
  if (model.renderPhoto) photo = model.renderPhoto;

  useEffect(() => {
    setIsLogin(hasLogin);
  }, [hasLogin])

  // ------------------- Request -------------------

  // 获取同名商标
  const request = useCallback(async () => {
    setLoading(true);
    const response = await Api.sameName(model.name);
    setLoading(false);
    if (!response.success) {
      message.error(response.errorDescribe);
      return;
    }
    setSameData(response.model!.list);
  }, [model]);

  // ------------------- Events -------------------

  // 点击 - 登录获取价格
  const onTapLogin = useCallback((e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(AppRouter.User.login({redirect: window.location.href}));
  }, []);

  // 点击 - 立即议价
  const onTapContact = useCallback((e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    KST.call();
  }, []);

  // 点击 - 多类别
  const onTapSameName = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();
      setModalVisible(true);

      if (!sameData && !loading) {
        request();
      }
    },
    [sameData, loading, request]
  );

  // 同名多类Modal取消
  const onModalCancel = useCallback(() => {
    setModalVisible(false);
  }, []);

  // ------------------- UI -------------------

  const modal = (
    <Modal
      width={700}
      bodyStyle={{ padding: 0 }}
      centered={true}
      destroyOnClose={true}
      closable={false}
      open={modalVisible}
      onCancel={onModalCancel}
      footer={null}
    >
      <Spin spinning={loading}>
        <div
          className={`${styles.modalContainer} flex-col flex-cross-axis-center`}
        >
          <div className={styles.title}>{`${model.name} - 同名商标`}</div>
          <div className="flex-row-wrap flex-main-axis-center">
            {(sameData ?? []).map((item, index) => {
              let photo = item.extend.photo;
              if (item.renderPhoto) photo = item.renderPhoto;
              return (
                <HYLink
                  key={index}
                  target="_blank"
                  className={`${styles.card} flex-col flex-cross-axis-center`}
                  href={AppRouter.TM.detail(item.code)}
                >
                  <img src={photo} alt={item.name} />
                  <div className={styles.category}>{item.uiCategory}</div>
                  <div className={styles.scope}>{item.uiScope}</div>
                  {hasLogin ? (
                    <div className={styles.price}>{item.uiPrice}</div>
                  ) : (
                    <div className={styles.getPrice} onClick={onTapLogin}>
                      登录获取价格
                    </div>
                  )}
                </HYLink>
              );
            })}
          </div>
        </div>
      </Spin>
    </Modal>
  );

  return (
    <HYLink
      target="_blank"
      className={`${styles.item} flex-col`}
      href={AppRouter.TM.detail(model.code)}
    >
      <div className={`${styles.content} flex-col`}>
        <div className="flex-row-center">
          <div
            className={styles.logo}
            style={{ backgroundImage: `url(${photo})` }}
          />
        </div>
        <div
          className={`${styles.nameContainer} flex-row flex-main-axis-between flex-cross-axis-center`}
        >
          <div className={`${styles.name}`}>{model.uiName}</div>
          {model.duplicateCount > 0 ? (
            <div className={styles.tag} onClick={onTapSameName}>
              多类别
            </div>
          ) : null}
        </div>
        <div className={styles.desc}>{model.uiScope}</div>
        <div className={styles.row4}>
          {hasLogin && <div className={styles.price}>{model.uiPrice}</div>}
        </div>
      </div>
      <div
        className={`${styles.buttonContainer} flex-row flex-main-axis-between`}
      >
        {!hasLogin && (
          <div
            className={`${styles.getPrice} flex-row-center`}
            onClick={onTapLogin}
          >
            登录查价
          </div>
        )}
        <div
          className={`${styles.contactNow} flex-row-center`}
          onClick={(e: any) => onTapContact(e)}
        >
          立即询价
        </div>
      </div>
      {modal}
    </HYLink>
  );
};

export default TMTransferListItem;
